<div id="signin-container" class="card page-card p-0">
    <div class="card-header">
        <h3><i class="fa fa-sign-in"></i> Login</h3>
    </div>
    <div class="card-body">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <!-- <div class="form-group">
                <input #username type="text" class="form-control" placeholder="Username"
                    [(ngModel)]="credentials.username" name="username" [required]="true">
            </div>
            <div class="form-group">
                <input #password type="password" class="form-control" placeholder="Password"
                    [(ngModel)]="credentials.password" name="password" [required]="true">
            </div>
            <hr/> -->
            <div class="form-inline">
                <label>Environment</label>
                <environment-switcher></environment-switcher>
            </div>
            <hr/>
            <button class="btn btn-large btn-primary" type="submit">Login</button>
        </form>
    </div>
</div>